import { doWaitImageByTime, doTransition } from './../helpers/helpers';
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { mc } from "../characters/MC";
import { images } from "./images";
import { V8AnnWebcamAfter } from "./V8";
import { Phone } from '../../src/components/phoneUI/PhoneClass';
import Game from '../../src/shell/Game';
import { endReplay } from '../../src/shell/endReplay';
import { replayScenesList } from '../../src/components/menu/Scenes/replayScenes/scenesReplayData';
import { annImages } from '../helpers/annInstaImages';

export const V8AnnWebcam = async (): Promise<any> => {
    doTransition({ ...images.v8.V8MCRoomAnnWebcam_0, partialsToDisplay: [images.v8.V8MCRoomAnnWebcam_0.partials.V8MCRoomAnnWebcam_0_p_1] });
    mc.think(`I believe now's a good time to webcam with Ann!`);
    await Phone.showMessagesUI({ name: ann.name, profileImage: annImages.Ann2 }, async () => {
        Phone.setMessage({ character: mc.character, text: `Hey Ann! Are you free right now?`, options: { wait: false } });
        Phone.setMessage({ character: ann.character, text: `Wow! I was just about to call you!\nYes! Now is a perfect time let me log in!` });
        Phone.setMessage({ character: mc.character, text: `Cool! Cya there!` });
        Phone.setMessage({ character: ann.character, text: `😘` });

        Phone.closeMessagesUI();
    });
    if (Game.seenScenarios.includes(`V8JennyDateBefore`)) {
        mc.think(`It's a bit weird to see Ann right finishing a date with Jenny...`);
        mc.think(`But I made my choice.`);

    }
    ImageClass.setImage(images.v8.V8MCRoomAnnWebcam_0.partials.V8MCRoomAnnWebcam_0_p);
    mc.think(`There we go...`);
    ImageClass.setImage(images.v8.V8MCRoomAnnWebcam_0.partials.V8MCRoomAnnWebcam_0_p_2);

    mc.talk(`I see you!`);
    ImageClass.setImage(images.v8.Anim_AnnFixCamera.poster);
    ann.talk(`Hey!!!`);
    mc.talk(`Hey!`);
    ann.talk(`Can you see me clearly?`);
    mc.talk(`Mmm... I think you need to adjust your camera.`);
    ann.talk(`Oh shoot! Sorry! Let me fix it.`);
    ImageClass.setAnimation(images.v8.Anim_AnnFixCamera, { duration: 0, loop: 0, wait: true });

    ann.talk(`How about now?`);
    mc.talk(`Now it's perfect!`);
    ImageClass.setImage(images.v8.V8MCRoomAnnWebcam_0);
    mc.talk(`Can you see me?`);
    ann.talk(`Hehe, I do!`);
    // ImageClass.setImage(images.v8.AnnDormNight_6);
    ImageClass.setImage({ ...images.v8.AnnDormNight_6, partialsToDisplay: [images.v8.AnnDormNight_6.partials.AnnDormNight_6_p] });
    ann.talk(`I know I already said this over text, but I want to apologize again...`);
    doWaitImageByTime(images.v8.AnnDormNight_6.partials.AnnDormNight_6_p_1);
    ann.talk(`I honestly had no idea they would call last minute to have me come over here early...`);
    ann.talk(`You were the only thing I was thinking of while talking to them...`);
    ImageClass.setImage({ ...images.v8.AnnDormNight_6, partialsToDisplay: [images.v8.AnnDormNight_6.partials.AnnDormNight_6_p] });
    ann.talk(`I was really looking forward to our date night...`);
    ann.talk(`But it's not like I'm going to be here too long! So rain check on that one!`);
    ImageClass.setImage(images.v8.AnnDormNight_6.partials.AnnDormNight_6_p_2);
    mc.talk(`I can't say I wasn't surprised, but it is what it is... Let's just forget about that and enjoy the rest of the night.`);
    ImageClass.setImage(images.v8.AnnDormNight_1);
    ann.talk(`Hehe! I'm so happy you are not mad at me.`);
    ImageClass.setImage(images.v8.AnnDormNight_0);
    mc.talk(`Don't be silly.`);
    mc.talk(`So, how are things there? Have you settled in already? I can see you are in a... dorm room?`);
    ImageClass.setImage(images.v8.AnnDormNight_2);
    ann.talk(`Oh yeah!`);
    ImageClass.setImage(images.v8.AnnDormNight_3);
    ann.talk(`As you can see, this dorm is occupied by a girl I haven't met yet.`);
    ImageClass.setImage(images.v8.AnnDormNight_1);
    ann.talk(`She is on her summer break but should return soon. I've talked to her over the phone just to let her know I won't steal anything... Hehe.`);
    ann.talk(`She sounds nice. I believe we'll get along if I happened to stay in this room in the future.`);

    ImageClass.setImage(images.v8.AnnDormNight_0);
    mc.talk(`So you are alone in the dorm and not expecting anyone...`);
    ImageClass.setImage(images.v8.AnnDormNight_1);
    ann.talk(`Hehe... Yes. Why?`);
    ImageClass.setImage(images.v8.AnnDormNight_0);
    mc.talk(`We can still have our date night then.`);
    ImageClass.setImage(images.v8.AnnDormNight_4);
    ann.talk(`Hehe.`);
    ann.talk(`How? I'm here and you are over there...`);
    ImageClass.setImage(images.v8.AnnDormNight_5);
    mc.talk(`Do you trust me?`);
    ImageClass.setImage(images.v8.AnnDormNight_7);
    ann.talk(`Of course.`);
    ImageClass.setImage(images.v8.AnnDormNight_6);
    mc.talk(`Follow my lead.`);
    mc.talk(`If you don't feel comfortable just tell me and we'll stop.`);
    ImageClass.setImage(images.v8.AnnDormNight_7);
    ann.talk(`Ok!`);
    mc.talk(`Let's start by lowering your cam. I want to see your body.`);
    ImageClass.setImage(images.v8.AnnDormNight_8);
    ann.talk(`That's easy! Give me a sec.`);
    ImageClass.setImage(images.v8.AnnDormNight_9, { wait: true, duration: 1, hideText: true });
    ImageClass.setImage(images.v8.AnnDormNight_10);
    ann.talk(`Is this good?`);
    mc.talk(`Perfect.`);
    mc.talk(`Now, place your hand on your pussy.`);
    ImageClass.setImage(images.v8.AnnDormNight_11);
    ann.talk(`What?! Are you serious?`);
    mc.talk(`Don't worry. I'll do the same.`);
    ImageClass.setImage(images.v8.V8MCRoomAnnWebcam_2);
    ann.talk(`Oh...`);
    ImageClass.setImage(images.v8.AnnDormNight_12);
    mc.talk(`Relax and imagine you are by yourself.`);
    ImageClass.setImage(images.v8.AnnDormNight_13);
    ann.talk(`It's hard... You are... Watching me.`);
    ImageClass.setImage(images.v8.AnnDormNight_12);
    mc.talk(`Watching you turns me on.`);
    ImageClass.setImage(images.v8.AnnDormNight_13);
    ann.talk(`...`);
    mc.talk(`Now slowly put your hand in your pants.`);
    mc.talk(`Don't worry, I'll be doing the same.`);

    ImageClass.setImage(images.v8.AnnDormNight_14, { wait: true, duration: 1, hideText: true });
    doWaitImageByTime(images.v8.AnnDormNight_15);
    mc.talk(`How does it feel?`);
    ann.talk(`Weird... But kinda exciting...`);
    ImageClass.setImage(images.v8.AnnDormNight_15.partials.AnnDormNight_15_p_2);
    mc.talk(`Do you want to stop?`);
    ImageClass.setImage(images.v8.AnnDormNight_15.partials.AnnDormNight_15_p);
    ann.talk(`... No...`);
    ImageClass.setImage(images.v8.AnnDormNight_15.partials.AnnDormNight_15_p_2);
    mc.talk(`I want to see more of you.`);
    ImageClass.setImage(images.v8.AnnDormNight_15.partials.AnnDormNight_15_p);
    ann.talk(`... W-What should I do?`);
    ImageClass.setImage(images.v8.AnnDormNight_15.partials.AnnDormNight_15_p_2);
    mc.talk(`Lift your shirt... I want to see your breasts.`);
    doWaitImageByTime(images.v8.AnnDormNight_16);
    ann.talk(`Mmmm... How's that?`);
    mc.talk(`Perfect.`);
    ImageClass.setImage(images.v8.AnnDormNight_17);
    mc.think(`Wow, she is really getting into this. I didn't even tell her to grab her breast.`);
    ImageClass.setImage(images.v8.V8MCRoomAnnWebcam_3);
    mc.think(`This is hot...`);
    ImageClass.setImage(images.v8.AnnDormNight_17);
    ann.talk(`Ah...`);


    if (mc.properties.alpha > 7) {
        mc.talk(`Take off your pants.`);
        ImageClass.setImage(images.v8.AnnDormNight_18);
        ann.talk(`Ok...`);

    } else {
        mc.talk(`Can you take off your pants?`);
        ImageClass.setImage(images.v8.AnnDormNight_18);
        ann.talk(`I can...`);
    }
    ImageClass.setImage(images.v8.AnnDormNight_19, { wait: true });
    ImageClass.setImage(images.v8.AnnDormNight_20);
    ann.talk(`There...`);
    mc.talk(`It's too dark... I can't see...`);
    ann.talk(`Oh...`);
    mc.talk(`Put your legs on the chair. I want to see you.`);
    doWaitImageByTime(images.v8.AnnDormNight_22);
    ann.talk(`I just had a thought... What if someone hacked my PC and is recording us?`);
    mc.talk(`Well then people will see the hottest girl on the internet...`);
    ImageClass.setImage(images.v8.AnnDormNight_21);
    ann.talk(`${mc.name}!`);
    mc.talk(`Don't worry! No one is recording us...`);
    ImageClass.setImage(images.v8.AnnDormNight_22);
    ann.talk(`Are you sure?`);
    mc.talk(`Of course.`);
    ImageClass.setImage(images.v8.AnnDormNight_21);
    ann.talk(`Ok... I trust you.`);
    mc.talk(`Well...`);
    ImageClass.setImage(images.v8.AnnDormNight_22);
    ann.talk(`What?`);
    mc.talk(`I want to see your whole body.`);
    mc.talk(`Open your legs.`);
    ann.talk(`Are you...`);
    ann.talk(`Sure?`);
    mc.talk(`Yes. It turns me on so much...`);
    ann.talk(`Ok...`);
    doWaitImageByTime(images.v8.AnnDormNight_23);
    mc.talk(`It's still too dark.`);
    ImageClass.setImage(images.v8.AnnDormNight_24);
    if (mc.properties.alpha > 7) {
        mc.talk(`Lower the camera a bit. I can't see anything!`);

    } else {
        mc.talk(`Can you lower the camera?`);
    }
    ImageClass.setImage(images.v8.AnnDormNight_25);
    ann.talk(`Let me try...`);
    doWaitImageByTime(images.v8.AnnDormNight_26);
    ann.talk(`Mmm...`);
    doWaitImageByTime(images.v8.AnnDormNight_27);
    ann.talk(`How's this?`);

    await mc.setQuestion(new Question({ text: `It's great.`, options: { think: false }, key: `V8AnnWebcamComplimentHer` })
        .option({ title: `Compliment her`, key: true })
        .option({ title: `Don't compliment`, key: false }));


    if (Question.globalAnswers.V8AnnWebcamComplimentHer) {
        await mc.set((properties) => {
            properties.annRelationship++;
        });
        mc.talk(`Your body is so hot.`);
        doWaitImageByTime(images.v8.AnnDormNight_27.partials.AnnDormNight_27_p);
        ann.talk(`Hehe.`);
        ImageClass.setImage(images.v8.AnnDormNight_27);
        ann.talk(`I also like your body...`);

    } else {

    }
    ImageClass.setImage(images.v8.AnnDormNight_27.partials.AnnDormNight_27_p_3);
    mc.talk(`I see that you trimmed yourself.`);
    // ImageClass.setImage(images.v8.AnnDormNight_27.partials.AnnDormNight_27_p_2);
    ImageClass.setImage({ ...images.v8.AnnDormNight_27, partialsToDisplay: [images.v8.AnnDormNight_27.partials.AnnDormNight_27_p_2, images.v8.AnnDormNight_27.partials.AnnDormNight_27_p_4] });
    ann.talk(`Vanessa convinced me to do it...`);
    mc.think(`I need to thank Vanessa later.`);
    ann.talk(`Do you like it?`);
    ImageClass.setImage(images.v8.AnnDormNight_27.partials.AnnDormNight_27_p_2);
    mc.talk(`I do.`);
    ImageClass.setImage(images.v8.AnnDormNight_27.partials.AnnDormNight_27_p_4);
    ann.talk(`So... What do we do now?`);
    mc.talk(`Start touching yourself while looking at me.`);
    doWaitImageByTime(images.v8.Anim_AnnDormMasturbateUpDown.poster);
    ann.talk(`It's so embarrassing...`);
    mc.talk(`It's only embarrassing if you make it embarrassing.`);
    mc.talk(`Start rubbing yourself slowly, and I'll do the same.`);
    ImageClass.setAnimation(images.v8.Anim_AnnDormMasturbateUpDown, { duration: 0 });

    // Ann rubbing
    mc.think(`This is so hot. I'm surprised she's actually doing this.`);
    mc.talk(`How does it feel?`);
    ann.talk(`It feels good... Real good.`);

    mc.talk(`Don't hold yourself back. Think that your hand is my hand. And how it is making you feel.`);
    ImageClass.setAnimation(images.v8.Anim_AnnMasturbateFast);
    ann.talk(`Ah...`);
    // ImageClass.setAnimation(images.v8.Anim_AnnDormReadyToMasturbateFast);
    // ImageClass.setImage(images.v8.Anim_AnnMasturbateFast.poster, { wait: 1, duration: 1 });
    ann.talk(`${mc.name}!!!`);


    mc.talk(`Insert your fingers.`);
    ImageClass.setImage(images.v8.Anim_AnnDormInsertFingers.poster);
    ann.talk(`Hmmm... What? Really?`);
    mc.talk(`Don't you usually do it?`);
    ann.talk(`No...`);
    mc.talk(`Well, just lower your hand and slowly insert your fingers...`);
    ann.talk(`I'll try...`);
    // anim
    ImageClass.setAnimation(images.v8.Anim_AnnDormInsertFingers, { loop: 0 });
    ann.talk(`Ah...`);
    mc.talk(`Still feeling good?`);
    ann.talk(`Yes...`);
    mc.talk(`Now start pulling them out and pushing them back in.`);
    ImageClass.setAnimation(images.v8.Anim_AnnDormMasturbateWithFingers);
    ann.talk(`Ah... Ohhhh... Hmmmmm...`);
    mc.talk(`How are you feeling now?`);
    ann.talk(`So much better than I thought I would...`);

    mc.talk(`It's so hot seeing you doing this.`);
    mc.talk(`Now relax... And do what makes you feel good.`);
    ImageClass.setAnimation(images.v8.Anim_ResetMasturbatePose, { loop: 0 });
    ann.talk(`Ok...`);

    ImageClass.setAnimations([
        { ...images.v8.Anim_AnnDormMasturbateUpDown, options: { loop: [1, 2] } },
        { ...images.v8.Anim_AnnDormReadyToMasturbateFast, options: { loop: 1 } },
        { ...images.v8.Anim_AnnMasturbateFast, options: { loop: [3, 5] } },
        { ...images.v8.Anim_AnnDormInsertFingers, options: { loop: 1 } },
        { ...images.v8.Anim_AnnDormMasturbateWithFingers, options: { loop: [2, 5] } },
        { ...images.v8.Anim_ResetMasturbatePose, options: { loop: 1 } },
    ]);

    ann.talk(`Mmmmhhmmm... `);
    ann.talk(`Yes... Ahhhhh...`);
    mc.think(`Wow, she has really loosened herself up. And it sounds like she is getting real wet.`);

    ImageClass.setImage(images.v8.AnnDormNight_35);
    ann.talk(`Ah!!!!`);
    doWaitImageByTime({ ...images.v8.AnnDormNight_36, partialsToDisplay: [images.v8.AnnDormNight_36.partials.AnnDormNight_36_p] });
    ann.talk(`Wow...`);
    ImageClass.setImage(images.v8.AnnDormNight_36);
    mc.talk(`How was it?`);
    ImageClass.setImage(images.v8.AnnDormNight_36.partials.AnnDormNight_36_p);
    ann.talk(`Wow... honestly I didn't believe it would feel that good...`);
    ImageClass.setImage(images.v8.AnnDormNight_36);
    mc.talk(`That doesn't mean I'm canceling our date!`);
    ImageClass.setImage(images.v8.AnnDormNight_36.partials.AnnDormNight_36_p_2);
    ann.talk(`Hehe, of course not!`);
    doWaitImageByTime({ ...images.v8.AnnDormNight_36, partialsToDisplay: [images.v8.AnnDormNight_36.partials.AnnDormNight_36_p] });
    ann.talk(`Did you... Cum?`);
    ImageClass.setImage(images.v8.AnnDormNight_36);
    await mc.talk(`Not yet...`);
    doWaitImageByTime({ ...images.v8.AnnDormNight_36, partialsToDisplay: [images.v8.AnnDormNight_36.partials.AnnDormNight_36_p] });
    ann.talk(`Is there something I can do to help?`);
    ImageClass.setImage(images.v8.AnnDormNight_36);
    mc.talk(`Yes...`);
    mc.talk(`Stand up.`);
    doWaitImageByTime(images.v8.AnnDormNight_31);
    ann.talk(`Hehe. Ok.`);

    mc.talk(`Now turn around for me.`);
    doWaitImageByTime(images.v8.AnnDormNight_29);
    ann.talk(`Like this?`);
    mc.talk(`Perfect.`);

    mc.talk(`Now, bend over.`);
    doWaitImageByTime(images.v8.AnnDormNight_30);
    ann.talk(`Hehe, you are so silly!`);

    ImageClass.setImage(images.v8.V8MCRoomAnnWebcam_4);
    mc.talk(`Ahh!!!`);
    ImageClass.setImage({ ...images.v8.AnnDormNight_30, partialsToDisplay: [images.v8.AnnDormNight_30.partials.AnnDormNight_30_p] });
    ann.talk(`It worked!`);

    ImageClass.setImage(images.v8.AnnDormNight_30);
    ann.talk(`Ok, I think this is enough for tonight. I need to sleep!`);
    mc.talk(`One last thing before you go!`);
    ImageClass.setImage(images.v8.AnnDormNight_30.partials.AnnDormNight_30_p);
    ann.talk(`Yes?`);
    mc.talk(`Lift your shirt.`);
    ImageClass.setImage(images.v8.AnnDormNight_30);
    ann.talk(`Hehe, and that's it! I'm going to sleep!`);
    mc.talk(`Of course.`);
    ImageClass.setImage(images.v8.AnnDormNight_31, { wait: true, hideText: true, duration: 1 });
    ImageClass.setImage(images.v8.AnnDormNight_33, { wait: true, duration: 1 });
    ImageClass.setImage(images.v8.AnnDormNight_32, { wait: false, duration: 1 });
    mc.talk(`I want to touch your body so much right now!`);

    ann.talk(`Hehe! Good night ${mc.name}!`);
    ImageClass.setImage(images.v8.AnnDormNight_34);
    ann.talk(`MUAH!`);
    await endReplay(replayScenesList.v8AnnWebcam);

    return jump(V8AnnWebcamAfter, "V8AnnWebcamAfter");
};;
